export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/DatabaseWorker.edf3b8b2.worker.js");
}
